import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { sectionData } from "../../portfolioData";

import "./index.css";

const Home = () => {
  const theme = useSelector((state) => state.theme);
  const textColor = theme === "LIGHT" ? "home-light" : "home-dark";
  const backgroundUrl =
    theme === "LIGHT"
      ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696071129/Portfolio%20App/Mode_Light_q8aoxp.png"
      : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696071140/Portfolio%20App/Mode_Dark_pth2gj.png";

  const homeContactCaption =
    theme === "LIGHT"
      ? "home-contact-container-caption-light"
      : "home-contact-container-caption-dark";

  const sectionCard = (data) => {
    const { id, displayText, caption, imageUrl } = data;
    const cardClass =
      theme === "LIGHT" ? "section-card-light" : "section-card-dark";

    return (
      <Link to={`/${id}`}>
        <div className={`section-card ${cardClass}`}>
          <h2>{displayText}</h2>
          <p>{caption}</p>
          <img src={imageUrl} alt="section" />
        </div>
      </Link>
    );
  };

  return (
    <div
      className={`home ${textColor}`}
      id="homeSection"
      style={{
        backgroundImage: `url(${backgroundUrl})`,
      }}
    >
      <h1 className="home-welcome">
        Welcome to my <br /> Creative Space!
      </h1>
      <p className="home-tagline">
        Crafting Seamless User Experiences through Code and Creativity.
      </p>
      <h1 className="home-name">
        <span>I'm</span> <wbr /> Om Kumbhare
      </h1>
      <p className="home-introduction">
        A front-end developer helping startups turn their visions into a digital
        reality. I specialize in designing and building modern mobile and
        web-based apps.
      </p>
      <section className="home-buttons-container">
        <a
          href="https://docs.google.com/document/d/1kMZfeE_iFwegN-AT05JQ_E7bcz377eXeUbU1A02MeZs"
          target="blank"
        >
          <button type="button" className="home-button button-resume">
            See my Resume
          </button>
        </a>
        <Link to="/contact">
          <button
            type="button"
            className={
              theme === "LIGHT"
                ? "home-button button-light"
                : "home-button button-dark"
            }
          >
            Get in Touch
          </button>
        </Link>
      </section>
      <ul className="section-card-container row mt-5 mb-5">
        {sectionData.map((data) => (
          <li key={data.id} className="col-12 col-sm-6  p-2">
            {sectionCard(data)}
          </li>
        ))}
      </ul>
      <section className="home-contact-container">
        <div>
          <h2>Let's Work Together</h2>
          <p className={homeContactCaption}>
            Want to discuss an opportunity to create something great? I’m ready
            when you are.
          </p>
        </div>
        <Link to="/contact">
          <button type="button" className="home-contact-button">
            <img
              src="https://res.cloudinary.com/ddaimmqrr/image/upload/v1696177552/Portfolio%20App/Send_t494gs.png"
              alt="send icon"
            />{" "}
            Get in Touch
          </button>
        </Link>
      </section>
    </div>
  );
};

export default Home;
